import axios from 'axios';
import { Container, Form, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { root_url } from '../setting';
const SearchId = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const { name, cellphone } = data;
    axios({
      method: 'post',
      url: `${root_url}/api/find/join-seq`,
      data: {
        runnerName: name,
        cellphone,
      },
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => {
        alert('해당번호로 SMS가 전송되었습니다. 확인해주세요.');
      })
      .catch((e) => {
        console.log(e);
        if (e.response === undefined) {
          alert(
            '시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)'
          );
        } else {
          alert(e.response.data.errorMessage);
          //   alert(`해당 정보로 참가신청되지 않았습니다.`);
        }
      });
  };
  return (
    <Container>
      <h1 className="mt-3 mb-5">접수 번호 찾기</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId="formName" className="mt-3 mb-5">
          <Form.Label>이름</Form.Label>
          {/* <Form.Control
        type="text"
        placeholder="홍길동"
        value={name}
        onChange={onChangeName}
      /> */}
          <input
            type="text"
            className="form-in-class"
            placeholder="홍길동"
            {...register('name', {
              required: true,
              maxLength: 50,
              pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
            })}
          />
          {errors.name && (
            <span
              className="position-absolute"
              style={{ fontSize: '0.8rem', color: 'red' }}
            >
              (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
            </span>
          )}
        </Form.Group>
        <Form.Group controlId="formPhoneNumber" className="mt-3 mb-5">
          <Form.Label>전화번호</Form.Label>
          {/* <Form.Control
        type="number"
        placeholder="01012345678(-없이 입력)"
        value={phoneNum}
        onChange={onChangePhoneNum}
        onKeyPress={onPressPhoneNum}
      /> */}
          <input
            type="number"
            className="form-in-class"
            placeholder="01012345678"
            {...register('cellphone', {
              required: true,
              maxLength: 11,
              pattern: /^[0-9]{4,11}/g,
            })}
          />
          {errors.cellphone && (
            <span
              className="position-absolute"
              style={{ fontSize: '0.8rem', color: 'red' }}
            >
              (필수)전화번호는 4자 이상, 11자 이하의 숫자만 입력해주세요.
            </span>
          )}
        </Form.Group>
        <input
          type="submit"
          className="bg-custom-color p-2 rounded text-white mb-5"
          style={{ border: 'none' }}
          value="SMS로 전송하기"
        />
      </form>
    </Container>
  );
};
export default SearchId;
